// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"276":"bb2a2fbe","867":"79732b2f"}[chunkId] + ".chunk.css");